export default __webpack_public_path__ + "static/media/AM2 Logo Colour Light.feaaf346.png";